import { useState, useEffect } from 'react';
import ProductForList, { ProductForListTypes } from '../../components/ProductComponents/ProductForList';
import { i18n } from '../../lang/i18n';
import { useAppSelector } from '../../store/hooks';

interface Props
{
    productCode: string,
    type: string,
}
export default function ProductsBlock(props: Props)
{
    const appData = useAppSelector((state) => state.appData)
    const productsDic = appData.productsDic;
    const [products, setProducts] = useState<any[]>([])
    const [title, setTitle] = useState<string>('')

    useEffect(() =>
    {
        let p = productsDic[props.productCode]
        if (props.type === 'category') {
            setTitle(i18n.ProductsBlock.SimilarProducts)
            let cats = appData.products.filter((value: any) => value.categoryId === p.categoryId)
            if (cats.length > 0)
                setProducts(cats[0].items)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.type])


    if (products.length === 0)
        return <></>
    return <div className="products-block-gray">
        <div>
            <div className="title" >
                {title}
            </div>
        </div>
        <div className="d-flex flex-row overflow-auto">
            {products.map((item: any, index: number) => (
                item.productCode !== props.productCode && <div className="col-6 col-md-4  pb-2 d-flex m-1" key={index}>
                    <ProductForList product={item} type={ProductForListTypes.Full} locationCode={appData.location.code} />
                </div>
            ))}
        </div>
    </div>
}